import { Box, Stack, Typography } from "@mui/material";

import StockPageHeader from "../../../components/StockPageHeader";
import { PURCHASE_STATUS, PURCHASE_STATUS_LABELS } from "../utils/purchaseModel";

export default function PurchaseDetailHeader({ purchase, creationDate, onBack }) {
  const approved = purchase?.status === PURCHASE_STATUS.APPROVED;
  const statusLabel = purchase
    ? PURCHASE_STATUS_LABELS[purchase.status]
    : "Cargando...";

  return (
    <Stack
      spacing={0}
      sx={{ alignItems: "center", justifyContent: "center" }}
    >
      <Box sx={{ width: "100%" }}>
        <StockPageHeader title="Lista de Compra" onBack={onBack} />
      </Box>
      <Box
        sx={{
          minWidth: { xs: 230, sm: 310 },
          maxWidth: { xs: "90vw", sm: 500 },
          px: 2,
          py: 0.65,
          bgcolor: "neutral.100",
          borderRadius: "0 0 9px 9px",
        }}
      >
        {purchase ? (
          <Stack
            direction="row"
            spacing={0.75}
            useFlexGap
            sx={{ alignItems: "center", justifyContent: "center", overflow: "hidden" }}
          >
            <Typography
              noWrap
              title={purchase.supplier?.name}
              sx={{ color: "primary.900", fontSize: 11, fontWeight: 650 }}
            >
              {purchase.supplier?.name || "Sin proveedor"}
            </Typography>
            <Typography sx={{ color: "neutral.600", fontSize: 10 }}>-</Typography>
            <Typography noWrap sx={{ color: "primary.900", fontSize: 11, fontWeight: 650 }}>
              {creationDate}
            </Typography>
            <Typography sx={{ color: "neutral.600", fontSize: 10 }}>-</Typography>
            <Typography
              noWrap
              sx={{
                color: approved ? "rgba(18, 111, 63, 1)" : "primary.900",
                fontSize: 11,
                fontWeight: 750,
              }}
            >
              {statusLabel}
            </Typography>
          </Stack>
        ) : (
          <Typography
          sx={{
            color: "primary.900",
            fontSize: 11,
            fontWeight: 650,
            textAlign: "center",
          }}
        >
            {statusLabel}
        </Typography>
        )}
      </Box>
    </Stack>
  );
}
